import React from 'react';
import { APITypes } from '../../../primary-record-types';
import { FormStack } from '../../v2BaseComponents/Stack';
import { Field } from 'formik';
import { FormikInputs } from '../../v2BaseComponents/Inputs';
import { composeValidators, email, phoneNumber, required } from '../../../utils/validators';
import { getIntl } from '../../../utils/intl';
import { FormDirtyStateTracker } from '../FormExitValidation';
import { SplitFormRow } from '../../v2BaseComponents/Form';

const intl = getIntl('organization-client-billing-info-fields', {
    name: 'Billing Contact Name',
    email: 'Billing Contact Email',
    phoneNumber: 'Billing Contact Phone Number',
});

export type EditClientBillingInfoFieldsOwnProps = {};

export type EditClientBillingInfoFieldsProps = EditClientBillingInfoFieldsOwnProps;

export type FormValue = APITypes.organizationService.UpdateOrganizationClientRecordBillingDetailsRequest;

export const getDefaultFormValue = (
    billingInfo: APITypes.organizationService.GetOrganizationClientRecordBillingDetailsResponse,
): FormValue => {
    if (billingInfo.status === 'insufficient-information') {
        return {
            name: billingInfo.name || '',
            email: billingInfo.email || '',
            phoneNumber: billingInfo.phoneNumber || '',
        };
    } else {
        return {
            name: billingInfo.name,
            email: billingInfo.email,
            phoneNumber: billingInfo.phoneNumber,
        };
    }
};

export const formValueToCreateClientRecordInvitationRequest = (
    formValue: FormValue,
): APITypes.organizationService.UpdateOrganizationClientRecordBillingDetailsRequest => {
    return {
        name: formValue.name,
        email: formValue.email,
        phoneNumber: formValue.phoneNumber || undefined,
    };
};

const EditClientBillingInfoFields: React.FC<EditClientBillingInfoFieldsProps> = (_props) => {
    return (
        <FormStack>
            <SplitFormRow>
                <Field name="name" title={intl('name')} component={FormikInputs.Input} validate={required} isRequired />
                <Field
                    name="email"
                    title={intl('email')}
                    component={FormikInputs.Input}
                    validate={composeValidators(required, email)}
                />
            </SplitFormRow>
            <SplitFormRow>
                <Field
                    name="phoneNumber"
                    title={intl('phoneNumber')}
                    component={FormikInputs.PhoneNumber}
                    validate={composeValidators(phoneNumber)}
                />
            </SplitFormRow>
            <FormDirtyStateTracker />
        </FormStack>
    );
};

export default React.memo(EditClientBillingInfoFields);
